import React, { Component, Fragment } from 'react';
import { observer, inject } from 'mobx-react';
import { withRouter } from "react-router";
import moment from 'moment';
import ExcelReader from 'components/common/FileController/ExcelReader';
import { ConfigProvider, Table, DatePicker, Select, List, Radio, Button, Statistic } from 'antd';
import { ArrowUpOutlined, ArrowDownOutlined } from '@ant-design/icons';

import koKr from 'antd/es/locale/ko_KR';
import 'moment/locale/ko';
import './StatsView.scss';
moment.locale('ko');

@inject('statsStore')
@observer
class StatsView extends Component {

  onSearch = () => {
    this.props.statsStore.disStatsGoods(null);
    this.props.statsStore.disStatsJob(null);
  };

  render() {
    const { cGbn } = this.props;
    const {
      valCondition,
      onChangValue,

      goodsList,
      jobList,
      statsGoods,
      statsJob,

      disStatsGoods,
      disStatsJob,
    } = this.props.statsStore;
    const columnsGoods = [
      { title: '사이즈',  dataIndex: 'stSize', width: 100, align: 'center' },
      { title: 'A 기간', width: 100, align: 'center',
        children: [
          { title: '판매수량', dataIndex: 'totalCnt', width: 100, align: 'center',
            render: (item, record) => { return(
              <Fragment>
                {item !== undefined && item !== null && item !== "" && item.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
              </Fragment>
            )}
          },
          { title: '판매금액', dataIndex: 'totalPrice', width: 100, align: 'center',
            render: (item, record) => { return(
              <Fragment>
                {item !== undefined && item !== null && item !== "" && item.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
              </Fragment>
            )}
          },
        ],
      },
      { title: 'B 기간', width: 100, align: 'center',
        children: [
          { title: '판매수량', dataIndex: 'totalCnt2', width: 100, align: 'center',
            render: (item, record) => { return(
              <Fragment>
                {item !== undefined && item !== null && item !== "" && item.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
              </Fragment>
            )}
          },
          { title: '판매금액', dataIndex: 'totalPrice2', width: 100, align: 'center',
            render: (item, record) => { return(
              <Fragment>
                {item !== undefined && item !== null && item !== "" && item.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
              </Fragment>
            )}
          },
        ],
      },
      { title: '비율', dataIndex: 'per', width: 100, align: 'center',
        render: (item, record) => { return(
          <Fragment>
            {item !== undefined && item !== undefined && 
              <Statistic
                value={Math.abs(parseInt(item))}
                precision={0}
                valueStyle={{ 
                  color: (parseInt(item) === 0) 
                  ? 'black'
                  : (parseInt(item) > 0) ? '#3f8600' : '#cf1322'
                }}
                prefix={
                  (parseInt(item) !== 0) 
                  && ((parseInt(item) > 0) ? <ArrowUpOutlined /> : <ArrowDownOutlined />)}
                suffix="%"
              />
            }
          </Fragment>
        )}
      },
    ];
    const columnsJob = [
      { title: '상품',  dataIndex: 'gdNm', width: 100, align: 'center' },
      { title: '성별', dataIndex: 'gdSex', width: 60, align: 'center' },
      { title: '사이즈', dataIndex: 'stSize', width: 100, align: 'center',
        render: (item, record) => { return(
          <Fragment>
            <List
              itemLayout="horizontal"
              dataSource={record.gdSizeList}
              renderItem={item => (
                <List.Item>
                  <List.Item.Meta
                    title={<Fragment>{item.stSize}</Fragment>}
                  />
                </List.Item>
              )}
            />
          </Fragment>
        )}
      },
      { title: 'A 기간', width: 100, align: 'center',
        children: [
          { title: '판매수량', dataIndex: 'totalCnt', width: 100, align: 'center',
            render: (item, record) => { return(
              <Fragment>
                <List
                  itemLayout="horizontal"
                  dataSource={record.gdSizeList}
                  renderItem={item => (
                    <List.Item>
                      <List.Item.Meta
                        title={
                          item.totalCnt !== undefined 
                          && item.totalCnt !== null && item.totalCnt !== "" && 
                          item.totalCnt.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                        }
                      />
                    </List.Item>
                  )}
                />
              </Fragment>
            )}
          },
          { title: '판매금액', dataIndex: 'totalPrice', width: 100, align: 'center',
            render: (item, record) => { return(
              <Fragment>
                <List
                  itemLayout="horizontal"
                  dataSource={record.gdSizeList}
                  renderItem={item => (
                    <List.Item>
                      <List.Item.Meta
                        title={
                          item.totalPrice !== undefined 
                          && item.totalPrice !== null && item.totalPrice !== "" && 
                          item.totalPrice.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                        }
                      />
                    </List.Item>
                  )}
                />
              </Fragment>
            )}
          },
        ],
      },
      { title: 'B 기간', width: 100, align: 'center',
        children: [
          { title: '판매수량', dataIndex: 'totalCnt2', width: 100, align: 'center',
            render: (item, record) => { return(
              <Fragment>
                <List
                  itemLayout="horizontal"
                  dataSource={record.gdSizeList}
                  renderItem={item => (
                    <List.Item>
                      <List.Item.Meta
                        title={
                          item.totalCnt2 !== undefined 
                          && item.totalCnt2 !== null && item.totalCnt2 !== "" && 
                          item.totalCnt2.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                        }
                      />
                    </List.Item>
                  )}
                />
              </Fragment>
            )}
          },
          { title: '판매금액', dataIndex: 'totalPrice2', width: 100, align: 'center',
            render: (item, record) => { return(
              <Fragment>
                <List
                  itemLayout="horizontal"
                  dataSource={record.gdSizeList}
                  renderItem={item => (
                    <List.Item>
                      <List.Item.Meta
                        title={
                          item.totalPrice2 !== undefined 
                          && item.totalPrice2 !== null && item.totalPrice2 !== "" && 
                          item.totalPrice2.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                        }
                      />
                    </List.Item>
                  )}
                />
              </Fragment>
            )}
          },
        ],
      },
      { title: '비율', dataIndex: 'percentage', width: 100, align: 'center',
          render: (item, record) => {
            const allTatalCnt = () => {
              let sumCnt = 0;
              record.gdSizeList.map(item=>{ return (
                  (item.totalCnt !== undefined && item.totalCnt !== null) &&
                  (sumCnt += parseFloat(item.totalCnt))
              )});
              return sumCnt;
            }
            const allTatalCnt2 = () => {
              let sumCnt = 0;
              record.gdSizeList.map(item=>{ return (
                  (item.totalCnt2 !== undefined && item.totalCnt2 !== null) &&
                  (sumCnt += parseFloat(item.totalCnt2))
              )});
              return sumCnt;
            }
            return(
            <Fragment>
              <Statistic
                // title="Active"
                value={
                  (allTatalCnt() === 0 && allTatalCnt2() === 0)
                  ? 0
                  : (allTatalCnt2() >= allTatalCnt() )
                    ? ((allTatalCnt2()-allTatalCnt())/allTatalCnt2())*100
                    : ((allTatalCnt()-allTatalCnt2())/allTatalCnt())*100
                }
                precision={0}
                valueStyle={{
                  color: (allTatalCnt() === allTatalCnt2()) 
                  ? 'black'
                  : (allTatalCnt() > allTatalCnt2()) ? '#3f8600' : '#cf1322'
                }}
                prefix={(allTatalCnt() !== allTatalCnt2()) &&
                  ((allTatalCnt() > allTatalCnt2()) ? <ArrowUpOutlined /> : <ArrowDownOutlined />)}
                suffix="%"
              />
            </Fragment>
          )}
      }
    ];

    return (
      <Fragment>
        <div className="button-group">
          <Radio.Group
            style={{ marginRight: '20px' }}
            size="large"
            value={valCondition.statsType}
            onChange={(e)=>{
              onChangValue('statsType', e.target.value);
              this.onSearch();
            }}
          >
            <Radio.Button value="month">월별</Radio.Button>
            <Radio.Button value="period">기간별</Radio.Button>
          </Radio.Group>
          <div className="button-right">
            <ul>
              <li>
                {/* 상품별 엑셀다운로드 */}
                <ExcelReader
                  actionType={'download'}
                  pageUrl={'DOWN-STATS-GOODS'}
                  schInfo={valCondition}
                />
              </li>
            </ul>
          </div>
        </div>
        
        <div className="search-box mo_srch_box">
          <div className="search-content" style={{float:'left'}}>
            <span className="mo_srch">
              <span className="labal2">A 기간</span> 
              <ConfigProvider locale={koKr}>
                {(valCondition.statsType === "month")
                ? <DatePicker
                    style={{ width: 150, marginRight: '20px' }}
                    picker="month"
                    format={'YYYY-MM'}
                    allowClear={false}
                    defaultValue={moment(moment().format('YYYY-MM'), 'YYYY-MM-DD')}
                    onChange={(date)=>{
                      onChangValue('date', moment(date).format('YYYY-MM'));
                      this.onSearch();
                    }}
                  />
                : <DatePicker.RangePicker
                    style={{ width: 270, marginRight: '20px' }}
                    format={'YYYY-MM-DD'}
                    allowClear={false}
                    defaultValue={[
                      moment(moment().subtract(1, 'month').format('YYYY-MM-DD').toString(), 'YYYY-MM-DD'), 
                      moment(moment().format('YYYY-MM-DD').toString(), 'YYYY-MM-DD')
                    ]}
                    onChange={(date)=>{
                      onChangValue('strDate', date[0].format('YYYY-MM-DD'));
                      onChangValue('endDate', date[1].format('YYYY-MM-DD'));
                      this.onSearch();
                    }}
                  />
                }
              </ConfigProvider>
            </span>
            <span className="mo_srch">
              <span className="labal2">B 기간</span> 
              <ConfigProvider locale={koKr}>
                {(valCondition.statsType === "month")
                ? <DatePicker
                    style={{ width: 150, marginRight: '20px' }}
                    picker="month"
                    format={'YYYY-MM'}
                    allowClear={false}
                    defaultValue={moment(moment().subtract(1, 'month').format('YYYY-MM'), 'YYYY-MM-DD')}
                    onChange={(date)=>{
                      onChangValue('date2', moment(date).format('YYYY-MM'));
                      this.onSearch();
                    }}
                  />
                : <DatePicker.RangePicker
                    style={{ width: 270, marginRight: '20px' }}
                    format={'YYYY-MM-DD'}
                    allowClear={false}
                    defaultValue={[
                      moment(moment().subtract(1, 'year').subtract(1, 'month').format('YYYY-MM-DD').toString(), 'YYYY-MM-DD'), 
                      moment(moment().subtract(1, 'year').format('YYYY-MM-DD').toString(), 'YYYY-MM-DD')
                    ]}
                    onChange={(date)=>{
                      onChangValue('strDate2', date[0].format('YYYY-MM-DD'));
                      onChangValue('endDate2', date[1].format('YYYY-MM-DD'));
                      this.onSearch();
                    }}
                  />
                }
              </ConfigProvider>
            </span>
          </div>
          <div className="search-button">
            <Button type="primary" onClick={this.onSearch}>조회</Button>
          </div>
        </div>

        <div className="button-group">
          <h3 className="h3_st">▶ 상품 &nbsp;&nbsp;&nbsp;&nbsp;
            <Select
              style={{ width: 250, marginRight: '20px' }}
              value={valCondition.gdCd}
              onChange={(value)=>{
                disStatsGoods(value);
              }}
            >
              {goodsList.map(item=>{ return (
                <Select.Option key={item.gdCd}>{item.gdNm}</Select.Option>
              )})}
            </Select>
          </h3>
        </div>

        <div className="table-border_st_b">
        <Table
          bordered
          rowKey={(record)=>record.stSize}
          columns={columnsGoods}
          dataSource={statsGoods}
          pagination={false}
        />
        {(statsGoods.length > 0) &&
          <table className="st_b">
            <colgroup>
              <col style={{width: '100px', minWidth:'100px'}}/>
              <col style={{width: '100px', minWidth:'100px'}}/>
              <col style={{width: '100px', minWidth:'100px'}}/>
              <col style={{width: '100px', minWidth:'100px'}}/>
              <col style={{width: '100px', minWidth:'100px'}}/>
              <col style={{width: '100px', minWidth:'100px'}}/>
            </colgroup>
            <tbody>
              <tr>
                <td className="b_01"></td>
                <td className="b_02"></td>
                <td className="b_03"></td>
                <td className="b_02"></td>
                <td className="b_03"></td>
                <td className="b_01"></td>
              </tr>
            </tbody>
          </table>
        }
        </div>
        {(cGbn === process.env.REACT_APP_TYPE_COMPANY_SAMSUNG) && 
        <Fragment>
          <div className="button-group">
            <h3 className="h3_st">▶ 직무 &nbsp;&nbsp;&nbsp;&nbsp;
              <Select
                style={{ width: 250, marginRight: '20px' }}
                value={valCondition.jobCd}
                onChange={(value)=>{
                  disStatsJob(value);
                }}
              >
                {jobList.map(item=>{ return (
                  <Select.Option key={item.jobCd}>{item.jobNm}</Select.Option>
                )})}
              </Select>
            </h3>
          </div>
          
          <div className="table-border_st_b">
            <Table
              bordered
              rowKey={(record)=>record.gdNm}
              columns={columnsJob}
              dataSource={statsJob}
              pagination={false}
            />
            {(statsJob.length > 0) &&
            <table className="st_b">
              <colgroup>
                <col style={{width: '100px', minWidth:'100px'}}/>
                <col style={{width: '60px', minWidth:'60px'}}/>
                <col style={{width: '100px', minWidth:'100px'}}/>
                <col style={{width: '100px', minWidth:'100px'}}/>

                <col style={{width: '100px', minWidth:'100px'}}/>
                <col style={{width: '100px', minWidth:'100px'}}/>
                <col style={{width: '100px', minWidth:'100px'}}/>
                <col style={{width: '100px', minWidth:'100px'}}/>
              </colgroup>
              <tbody>
                <tr>
                  <td className="b_02"></td>
                  <td className="b_04"></td>
                  <td className="b_03"></td>
                  <td className="b_02"></td>

                  <td className="b_03"></td>
                  <td className="b_02"></td>
                  <td className="b_03"></td>
                  <td className="b_01"></td>
                </tr>
              </tbody>
            </table>
            }
          </div>
        </Fragment>}
        <br />
      </Fragment>
    );
  }

}

export default withRouter(StatsView);
